import { Redirect } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { queryParams } from "../Store/GetSearch";

export default function LandingPage(props) {
	const { search } = useLocation();

	return <Redirect to={`/trace${queryParams(search, "urlQuery") ? "?gSerial=" + queryParams(search, "urlQuery") : ""}`} />;
}
